/* eslint-disable @typescript-eslint/no-explicit-any */
import PackageRepository from "@/utilities/repositories/Package";
import { FC, useCallback, useEffect, useState } from "react";
import PackageCard from "./PackageCard";
import { IPackage } from "@/utilities/types/Package";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";

interface PackageConfigurationsProps {
  name: string;
}

const PackageConfigurations: FC<PackageConfigurationsProps> = () => {
  const [packages, setPackages] = useState<IPackage[]>([]);
  const [currentPackage, setCurrentPackage] = useState<IPackage | null>(null);
  const [userPackageId, setUserPackageId] = useState<string>("");
  const [userPkgExpiredAt, setUserPkgExpiredAt] = useState<Date | null>(null);
  const { id: userId } = useParams();

  const removeUserPkg = () => {
    setCurrentPackage(null);
  };

  const updateCurrentPackage = (
    pkg: IPackage,
    userPkgId: string,
    expiredAt: Date
  ) => {
    setCurrentPackage(pkg);
    setUserPackageId(userPkgId);
    setUserPkgExpiredAt(expiredAt);
  };

  const removeOrUpdateUserPkg = (data?: {
    pkg: IPackage;
    userPkgId: string;
    expiredAt: Date;
  }) => {
    if (data) {
      updateCurrentPackage(data.pkg, data.userPkgId, data.expiredAt);
    } else {
      removeUserPkg();
    }
  };

  const fetchPackages = useCallback(async () => {
    // Fetch packages from the server
    if (userPackageId) return;
      try {
        const response = await PackageRepository.getPackageList({});

        const pkgs = response.data.items || [];

        const pkgsData: IPackage[] = pkgs.slice();

        setPackages(pkgsData);
      } catch (error: any) {
        toast.error(error?.message || "Error fetching packages");
        return [];
      }
  }, []);

  const fetchPackageCurrent = useCallback(async () => {
    // Fetch current package for the user
    try {
      const response = await PackageRepository.getUserPackage(userId || "");
      const data = response?.data || {};
      setUserPackageId(data?.id || "");
      setUserPkgExpiredAt(data?.expiredAt ? new Date(data.expiredAt) : null);

      const pkg = data?.package;
      if (pkg) {
        setCurrentPackage(pkg);
      }
    } catch (error) {
      toast.error("Error fetching current package");
      return null;
    }
  }, [userId]);

  useEffect(() => {
    Promise.all([fetchPackageCurrent(), fetchPackages()]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (currentPackage) {
    return (
      <div className="flex flex-col gap-1">
        <h2 className="text-lg font-semibold">Current Package</h2>
        <PackageCard
          userPackageId={userPackageId}
          pkg={currentPackage}
          callback={removeOrUpdateUserPkg}
          userPkgExpiredAt={userPkgExpiredAt}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <h2 className="text-lg font-semibold">Package Configurations</h2>
      {/* Add configuration options here */}
      <div className="flex flex-wrap gap-6">
        {packages.map((pkg) => (
          <PackageCard
            key={pkg.id}
            pkg={pkg}
            callback={removeOrUpdateUserPkg}
            isRoot
          />
        ))}
      </div>
    </div>
  );
};
export default PackageConfigurations;
